import { searchConfig } from '@cocoonspace/shared/config/search-config'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { useMemo } from 'react'

import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '~/components/ui/select'

import type { TimeSlot } from '../../templates/booking-stepper'

interface TextTimeSelectProps {
	value: TimeSlot
	type: keyof TimeSlot
	onChange: (value: string) => void
}

export const TextTimeSelect = ({
	value,
	type,
	onChange,
}: TextTimeSelectProps) => {
	const options = useMemo(() => {
		return searchConfig.timeSlots.filter((timeSlot) => {
			if (type === 'start') {
				return (
					dateTimeUtils.utils.getTimeAsMinutes(value.end!) >
					dateTimeUtils.utils.getTimeAsMinutes(timeSlot)
				)
			}

			if (type === 'end') {
				return (
					dateTimeUtils.utils.getTimeAsMinutes(value.start!) <
					dateTimeUtils.utils.getTimeAsMinutes(timeSlot)
				)
			}

			return timeSlot
		})
	}, [type, value.end, value.start])

	return (
		<Select
			value={value[type]}
			onValueChange={onChange}
		>
			<SelectTrigger className='h-auto w-auto rounded-[6px] border border-slate-200 px-2 py-0 font-semibold text-primary hover:border-slate-500'>
				<SelectValue />
			</SelectTrigger>

			<SelectContent className='z-50 bg-white'>
				<SelectGroup>
					{options.map((option) => (
						<SelectItem
							key={option}
							value={option}
						>
							{option}
						</SelectItem>
					))}
				</SelectGroup>
			</SelectContent>
		</Select>
	)
}
